import Box from 'UIKit/Box/Box'
import useMatchBreakpoints from 'hooks/useMatchBreakpoints'
import { useDailyRewardCampaign } from 'state/bonus/hooks/dailyReward'
import { colors } from 'theme/colors'
import BonusCenterMenu from './component/BonusCenterMenu'
import DailyCheckinMenu from './component/DailyCheckinMenu'
import LuckySpinMenu from './component/LuckySpinMenu'
import TournamentMenu from './component/TournamentMenu'

const ExtendMenu = () => {
  const { campaign } = useDailyRewardCampaign()
  const { isMobile } = useMatchBreakpoints()

  return (
    <Box background={colors.backgroundAlt5} p="4px" maxWidth={['', '', '', '212px']} borderRadius="4px">
      <BonusCenterMenu />
      {campaign && <DailyCheckinMenu />}
      <LuckySpinMenu />
      {isMobile && <TournamentMenu />}
    </Box>
  )
}

export default ExtendMenu
